import { render } from "./AirQuality.vue?vue&type=template&id=35799458"
import script from "./AirQuality.vue?vue&type=script&lang=js"
export * from "./AirQuality.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__